/* eslint-disable */
export default {
    path: 'https://ops.dev.nenly.cn/api/v1',
    terminal_prefix: "wss://",
    domain: "https://ops.dev.nenly.cn",
    // path: "http://localhost:8080/api/v1",
    // terminal_prefix: "ws://",
    // domain: "http://localhost:8081",
    pageSize: 15,
    resources: [
        "users",
        "roles",
        "mails",
        "ldaps",
        "dnszones",
        "dnsrecords",
        "k8sclusters",
        "k8sroles",
        "k8srolebindings",
        "kubeconfigs",
        "namespaces",
        "androids",
        "pods",
    ],
    actions: ["create", "delete", "update", "get", "list", "exec", "log"],
    setCookie: function(value, t) {
        var exdate = new Date();
        var expireDays = t;
        exdate.setTime(expireDays * 1000);
        document.cookie =
            "token=" +
            escape(value) +
            (expireDays == null ? "" : ";expires=" + exdate.toGMTString());
    },
    getCookie: function() {
        var arr,
            reg = new RegExp("(^| )token=([^;]*)(;|$)");
        return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null;
    },
    storageLoginInfo(data) {
        localStorage.setItem("user", JSON.stringify(data));
    },
    getLoginInfo() {
        let user = JSON.parse(localStorage.getItem("user"));
        return user;
    },
    isLogin() {
        if (this.getCookie() != null) {
            if (this.getLoginInfo() == null) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    },
    urlSearch() {
        var name, value;
        var str = location.href; //取得整个地址栏
        var num = str.indexOf("?");
        str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

        var arr = str.split("&"); //各个参数放到数组里
        for (var i = 0; i < arr.length; i++) {
            num = arr[i].indexOf("=");
            if (num > 0) {
                name = arr[i].substring(0, num);
                value = arr[i].substr(num + 1);
                this[name] = value;
            }
        }
    },
    clearInfo() {
        localStorage.clear();
        this.setCookie("", -1);
    },
};